<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="6" md8 sm12 xs24 v-for="(item, index) in empty" :key="index">
        <empty :icon="item.icon" :title="item.title" :sub-title="item.subTitle">
          <container :class="['text-xs']">
            <p v-html="$lang.customContent" :class="['py-3']" />
            <btn block color="white" size="xs" @click="onClick(item)" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" :color-lightness="null">{{ $lang.customButton }}</btn>
          </container>
        </empty>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageEmpty',
  mixins: [
    methods
  ],
  data () {
    return {
      empty: []
    }
  },
  mounted () {
    this.getExternalData('empty.json', 'empty')
  },
  methods: {
    onClick (item) {
      this.log('click', 'empty', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/empty.vue